export function getSelectedAccountNum(accountNumParam, accounts) {
    const numberOfAccounts = Object.keys(accounts).length;
    const activeAccounts = Object.values(accounts).filter(a => a.accountStatus === "Active");

    if (accountNumParam === "default") {
        if (numberOfAccounts === 1) {
            return Object.values(accounts)[0].accountNumber;
        } else if (numberOfAccounts > 1 && activeAccounts.length === 1) {
            return activeAccounts[0].accountNumber;
        }
    }
    return accountNumParam;
}
